import { getFullName } from '@domain/member';
import { MemberLight } from '@wwf/sdk';
import { MemberLightCard } from './show/MemberLightCard';

export const memberOptionText = <MemberLightCard noLink />;
export const memberInputText = (choice: MemberLight) => getFullName(choice);
